import {
    Autocomplete, Checkbox, Chip, FormControlLabel,
    Input,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import {useTheme} from '@mui/styles';
import {IconCurrencyShekel} from '@tabler/icons';
import {FormattedMessage} from 'react-intl';
import IItem, {
    hasSecondUnit,
    hasStoredSecondAmount,
    hasThirdUnit,
    orderColumnDisplay,
    secondUnitIndex,
    showsWrappedColumn,
    thirdUnitIndex,
    wrappedColumnDisplay,
    wrappedNetSecond
} from 'types/product_delivery';
import HoverableIncrementer from 'ui-component/HoverableIncrementer';
import JSDB from '../../../../fromKotlin/nk';
import {dateObjectToString, roundDecimals} from '../../../../fromKotlin/nkutils';
import React, {memo, useRef} from 'react';
import getCustomerProductsPrices, {getSupplierProductsPrices, itemApiIInternal} from '../../../../api/customer/products_prices.api';
import {
    applyTaklitPriceFromLookup,
    isTaklitEnabled,
    loadTaklitLookup,
} from '../../../../api/customer/taklitPrices';
import {TaklitProduct} from '../../../../api/customer/taklit.api';
import {handleKeyDown} from '../../../../utils/tableAsKeyBorad';
import {toArrayOrEmpty} from '../../../../types/DocumentsTypes/utils';
import {ExtendedDocument} from "../../../../types/DocumentsTypes/Document";
import {subStringMatch} from "../../../../utils/sort";
import {Percentage} from "tabler-icons-react";
import {CUSTOMER_PRODUCTS, SUPPLIER_PRODUCTS} from "../../../../hooks/customer/products.hooks";
import {useDispatch} from "react-redux";
import {useQuery, useQueryClient} from "react-query";
import {SNACKBAR_OPEN} from "../../../../store/actions";
import {isVariableConversionRate} from "../../../../utils/cofcFeatures";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface CustomerProductsPreviewListProps {
    products: IItem[];
    onProductChange?: (product: IItem, rowIndex?: number) => void;
    disableHoverableIncrementer?: boolean;
    withReturns?: boolean;
    date?: Date;
    id: string;
    sup?: boolean
    displayCost?: boolean;
    oldProducts?: IItem[] | undefined;
    displayOldProducts?: boolean;
    orderProducts?: IItem[] | undefined;
    displayOrderProducts?: boolean;
    collect?: boolean;
    jumpToWrapped?: boolean;
    /** Quote editor: Enter moves to the next product row. */
    enterMovesDown?: boolean;
    /** When set, the product column title is a toggle for catalog-position order. */
    sortByPosition?: boolean;
    onTogglePositionSort?: () => void;
}

const ProductRowMemo = React.memo(({
                                       row,
                                       onProductChange,
                                       i,
                                       disableHoverableIncrementer,
                                       withReturns,
                                       withExtraUnit,
                                       displayCost,
                                       displayNoteColumn,
                                       displayQuantityColumn,
                                       displayCostPrice,
                                       oldProducts,
                                       removedProduct,
                                       existingOrderProducts,
                                       orderProducts,
                                          withDiscount,
                                       externalIdSearch,
                                       jumpToWrapped,
                                       enterMovesDown,
                                       variableConversion,

                                   }: { row: IItem, onProductChange?: any, i: number, disableHoverableIncrementer: any, withReturns: boolean, withExtraUnit: boolean, displayCost?: boolean, displayNoteColumn?: boolean, displayQuantityColumn?: boolean, displayCostPrice?: boolean, oldProducts?: IItem[], removedProduct?: boolean, existingOrderProducts?: IItem[], orderProducts?: boolean, collect?: boolean,withDiscount?:boolean ,externalIdSearch?:boolean,jumpToWrapped?:boolean, enterMovesDown?: boolean, variableConversion?: boolean}) => {
    const oldQuantity = !oldProducts ? undefined : (removedProduct ? null : oldProducts?.find(item => item?.id === row?.id));
    const orderP = existingOrderProducts?.length || orderProducts ? (orderProducts ? row : existingOrderProducts?.find(item => item?.id === row?.id)) : undefined
    const secondIdx = secondUnitIndex(row);
    const thirdIdx = thirdUnitIndex(row);
    const secondUnitName = secondIdx >= 0 ? row.available_units[secondIdx] : undefined;
    const thirdUnitName = thirdIdx >= 0 ? row.available_units[thirdIdx] : undefined;
    const leftoverSecond = hasStoredSecondAmount(row);
    const showSecondAmount = hasSecondUnit(row) || leftoverSecond;
    const showWrappedCell = showsWrappedColumn(row);

    return <TableRow
        key={i}
        onKeyDown={(e) => handleKeyDown(e, { enterMovesDown })}
        sx={{
            '&:last-child td, &:last-child th': {border: 0},
            backgroundColor: row.isLocked ? '#95bdf6' : (removedProduct ? '#ffd1d1' : orderProducts ? "#cfeeff" : undefined)
        }}
    >
        <TableCell sx={{padding: 0}} align='left'>
            <Typography variant='h5'>      {externalIdSearch? row.external_id : row.id}  - {row.name}</Typography>


            <Typography variant='caption'> {row.barcode}</Typography>
        </TableCell>
        {existingOrderProducts?.length || orderProducts ? (
            <TableCell sx={{padding: 0}} align='center'>
                <Typography variant='h5' color={"#0288d1"}
                            fontWeight={"600"} sx={{whiteSpace: 'pre-line'}}>
                    {orderP ? orderColumnDisplay(orderP) : 0}
                </Typography>
            </TableCell>
        ) : undefined
        }
        {withExtraUnit ? showWrappedCell ?
            <TableCell sx={{padding: 0}} align='left'>

                {!onProductChange ? (
                    <Typography variant='h5' sx={{whiteSpace: 'pre-line'}}>
                        {!orderProducts && oldQuantity && oldQuantity.quantitySecond !== undefined && oldQuantity.quantitySecond !== row.quantitySecond ?
                            <span style={{color: 'red'}}>{oldQuantity.quantitySecond}  &nbsp; </span>
                            : undefined}
                        {wrappedColumnDisplay(row)}
                    </Typography>
                ) : (<>
                        {hasSecondUnit(row) && !jumpToWrapped && wrappedNetSecond(row) === 0 ? (
                            <Chip label={`${secondUnitName} +`} chipcolor={'success'} size='small'
                                  onClick={(e) => {
                                      onProductChange({
                                          ...row,
                                          quantitySecond: row.quantitySecond + 1
                                      });
                                  }}/>
                        ) : showSecondAmount ? (
                            <div><HoverableIncrementer
                                value={row.quantitySecond}
                                disabled={disableHoverableIncrementer}
                                onIncrement={() => {
                                    onProductChange({
                                        ...row,
                                        quantitySecond: row.quantitySecond + 1
                                    });
                                }}
                                onDecrement={() => {
                                    onProductChange({
                                        ...row,
                                        quantitySecond: Math.max(0, row.quantitySecond - 1)
                                    });
                                }}
                                onChange={(v) => {
                                    onProductChange({...row, quantitySecond: Math.max(0, v)});
                                }}
                            />
                                {secondUnitName ?
                                    <Typography variant='h5'>    &nbsp; {secondUnitName}   </Typography> : undefined}
                            </div>
                        ) : undefined}

                        {hasSecondUnit(row) && row?.conversion_ratio < 1 && row?.conversion_ratio > 0 ? ` = ${1 / row?.conversion_ratio} ${row?.available_units[0]}` : showSecondAmount && row.quantitySecond > 0 && row.conversion_ratio > 0 && !orderProducts ?
                            `${row.quantitySecond * row.conversion_ratio} ${row?.available_units[0]}`
                            : undefined}

                        {hasThirdUnit(row) ? (
                            <div style={{display: "flex", flexDirection: 'row'}}>
                                <HoverableIncrementer
                                    value={row.quantityThird ?? 0}
                                    disabled={disableHoverableIncrementer}
                                    onIncrement={() => {
                                        onProductChange({...row, quantityThird: (row.quantityThird ?? 0) + 1});
                                    }}
                                    onDecrement={() => {
                                        onProductChange({...row, quantityThird: Math.max(0, (row.quantityThird ?? 0) - 1)});
                                    }}
                                    onChange={(v) => {
                                        onProductChange({...row, quantityThird: Math.max(0, v)});
                                    }}
                                />
                                <Typography variant='h5'>    &nbsp; {thirdUnitName}   </Typography>
                            </div>
                        ) : undefined}
                    </>
                )}
            </TableCell> : <TableCell sx={{padding: 0}} align='left'>
                <Typography variant='h5'> </Typography>
            </TableCell> : undefined}

        {variableConversion && withExtraUnit ? (
            <TableCell sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
                {hasSecondUnit(row) ? (
                    !onProductChange ? (
                        <Typography variant='h5'>{row.conversion_ratio || ''}</Typography>
                    ) : (
                        <HoverableIncrementer
                            value={row.conversion_ratio ?? 0}
                            disabled={disableHoverableIncrementer}
                            onIncrement={() => {
                                onProductChange({...row, conversion_ratio: (row.conversion_ratio ?? 0) + 1});
                            }}
                            onDecrement={() => {
                                onProductChange({...row, conversion_ratio: Math.max(0, (row.conversion_ratio ?? 0) - 1)});
                            }}
                            onChange={(v) => {
                                onProductChange({...row, conversion_ratio: Math.max(0, v)});
                            }}
                        />
                    )
                ) : null}
            </TableCell>
        ) : undefined}

        <TableCell sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
            {!onProductChange ? (
                <div>
                    {!orderProducts ? <>
                        {(() => {
                            const oldCombined = oldQuantity ? ((oldQuantity.quantity ?? 0) + (oldQuantity.conversion_ratio ?? 0) * (oldQuantity.quantitySecond ?? 0)) : undefined;
                            const currentCombined = row.quantity + (row.conversion_ratio ?? 0) * (row.quantitySecond ?? 0);
                            const changed = oldCombined !== undefined && oldCombined !== currentCombined;
                            return <>
                                {changed ? <Typography variant='h5' style={{ color: 'red' }}>{oldCombined}</Typography> : undefined}
                                <Typography variant='h5' style={{ margin: "0 5px" }}>{currentCombined}</Typography>
                            </>;
                        })()}

                        {row.in_unit && row.in_unit > 0 && row.quantity > 0 ?
                            <Typography
                                variant='caption'>  {`${row.quantity * row.in_unit} יח'`}</Typography> : undefined}
                    </> : undefined}


                </div>
            ) : (
                <HoverableIncrementer
                    value={row.quantity}
                    disabled={disableHoverableIncrementer}
                    onIncrement={() => {
                        onProductChange({...row, quantity: row.quantity + 1});
                    }}
                    onDecrement={() => {
                        onProductChange({...row, quantity: Math.max(0, row.quantity - 1)});
                    }}
                    onChange={(v) => {
                        onProductChange({...row, quantity: Math.max(0, v)});
                    }}
                />
            )}
        </TableCell>

        {withReturns && (displayQuantityColumn || onProductChange) ? <TableCell sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
            {!onProductChange ? (
                <div>
                    {!orderProducts ? <>
                        {(oldQuantity && oldQuantity.quantityReturns !== undefined && oldQuantity.quantityReturns !== row.quantityReturns) ?
                            <Typography variant="h5" style={{
                                color: 'red',
                            }}>{oldQuantity.quantityReturns}   </Typography>
                            : undefined
                        }
                        <Typography variant='h5' style={{
                            margin: "0 5px"
                        }}>{row.quantityReturns}</Typography>
                    </> : undefined}

                </div>


            ) : (
                <HoverableIncrementer
                    value={row.quantityReturns}
                    disabled={disableHoverableIncrementer}
                    onIncrement={() => {
                        onProductChange({
                            ...row,
                            quantityReturns: row.quantityReturns + 1
                        });
                    }}
                    onDecrement={() => {
                        onProductChange({
                            ...row,
                            quantityReturns: Math.max(0, row.quantityReturns - 1)
                        });
                    }}
                    onChange={(v) => {
                        onProductChange({...row, quantityReturns: Math.max(0, v)});
                    }}
                />
            )}
        </TableCell> : undefined}

        <TableCell sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
            {!onProductChange ? (
                <> 
                    <span style={{color: (oldQuantity && oldQuantity.totalPrice !== undefined && oldQuantity.totalPrice !== row.totalPrice) ? 'red' : undefined}}>
                    {row.price_min && row.price_min!=row.price_max ?  `${row.price_min} - ${row.price_max}`: roundDecimals(row.totalPrice, 4)}
                    </span>
                    <IconCurrencyShekel size={10} color='black'/>
                </>
            ) : (
                <HoverableIncrementer
                    value={roundDecimals(row.totalPrice, 4)}
                    disabled={disableHoverableIncrementer}
                    wide
                    onIncrement={() => {
                        onProductChange({
                            ...row,
                            totalPrice: row.totalPrice + 1
                        });
                    }}
                    onDecrement={() => {
                        onProductChange({
                            ...row,
                            totalPrice: Math.max(0, row.totalPrice - 1)
                        });
                    }}
                    onChange={(v) => {
                        onProductChange({...row, totalPrice: Math.max(0, v)});
                    }}
                />
            )}
            {row.discount > 0 ?
                <Typography variant='caption' display='block' dir='ltr'
                            sx={{whiteSpace: 'nowrap', color: 'text.secondary'}}>
                    {`(${row.discount}%) => ${roundDecimals(row.totalPrice * (1 - row.discount / 100), 4)}`}
                </Typography> : ''}
        </TableCell>
        {withDiscount ?      <TableCell sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
            {!onProductChange ? (
                <>
                    {roundDecimals(row.discount, 4)}
                    <Percentage size={10} color='black'/>
                </>
            ) : (
                <HoverableIncrementer
                    value={roundDecimals(row.discount, 4)}
                    disabled={disableHoverableIncrementer}
                    onIncrement={() => {
                        onProductChange({
                            ...row,
                            discount: Math.min(row.discount + 1,100)
                        });
                    }}
                    onDecrement={() => {
                        onProductChange({
                            ...row,
                            discount: Math.max(0, row.discount - 1)
                        });
                    }}
                    onChange={(v) => {
                        onProductChange({...row, discount: Math.min(Math.max(0, v),100)});
                    }}
                />
            )}
        </TableCell>
            : undefined}
        <TableCell dir='ltr' sx={{py: 0, px: 0.5, whiteSpace: 'nowrap'}} align='center'>
            {(() => {
                const currentTotal = row.total ? row.total : roundDecimals((row.totalPrice * (1 - row.discount / 100)) * (row.quantity - row.quantityReturns + (row.quantitySecond ?? 0) * (row.conversion_ratio ?? 0)), 4);
                const oldTotal = oldQuantity ? roundDecimals(((oldQuantity.totalPrice ?? row.totalPrice) * (1 - (oldQuantity.discount ?? 0) / 100)) * ((oldQuantity.quantity ?? 0) - (oldQuantity.quantityReturns ?? 0) + (oldQuantity.quantitySecond ?? 0) * (oldQuantity.conversion_ratio ?? 0)), 4) : undefined;
                const changed = oldTotal !== undefined && oldTotal !== currentTotal;
                return <>

                    <span>{currentTotal}</span>
                </>;
            })()}
            <IconCurrencyShekel size={10} color='black'/>
        </TableCell>
        {displayCost && displayCostPrice ?
            <TableCell dir='ltr' sx={{py: 0, px: 0.5, whiteSpace: 'nowrap', backgroundColor: removedProduct ? '#ffadad' : '#F6F6F6'}}
                       align='center'>
                {
                    !onProductChange ? (
                        <>
                            {row.costPrice ? roundDecimals(row.costPrice, 4) : ""}
                            {row.costPrice ? <IconCurrencyShekel size={10} color='black'/> : ""}
                        </>
                    ) : (
                        <HoverableIncrementer
                            value={row.costPrice ? roundDecimals(row.costPrice, 4) : 0}
                            disabled={disableHoverableIncrementer}
                            wide
                            onIncrement={() => {
                                onProductChange({
                                    ...row,
                                    costPrice: row.costPrice ? row.costPrice + 1 : 1
                                });
                            }}
                            onDecrement={() => {
                                onProductChange({
                                    ...row,
                                    costPrice: Math.max(0, row.costPrice ? row.costPrice - 1 : 0)
                                });
                            }}
                            onChange={(v) => {
                                onProductChange({...row, costPrice: Math.max(0, v)});
                            }}
                        />
                    )
                }
            </TableCell>
            : undefined
        }
        {displayNoteColumn || onProductChange ?
            <TableCell dir='rtl' sx={{padding: 0, width: 30}} align='center'>
                {!onProductChange ? (
                    <>
                        <Typography variant='h5'>      {row.notes ?? ''}</Typography>
                    </>
                ) : <Input
                    type='text'
                    onChange={(v) => {
                        onProductChange({...row, notes: v.target.value});
                    }}
                    value={row.notes}
                />}

            </TableCell>
            : undefined
        }
    </TableRow>

})

const CustomerProductsPreviewList = ({
                                         products,
                                         onProductChange,
                                         disableHoverableIncrementer = false,
                                         withReturns = true,
                                         date = new Date(),
                                         id,
                                         sup = false,
                                         displayCost = false,
                                         oldProducts,
                                         displayOldProducts,
                                         orderProducts,
                                         displayOrderProducts,
                                         collect,
     jumpToWrapped,
     enterMovesDown,
     sortByPosition,
     onTogglePositionSort
                                     }: CustomerProductsPreviewListProps) => {
    const theme = useTheme();
    const cache = useQueryClient();
    const dispatch = useDispatch();
    const [onlyClientProduct, setOnlyClientProduct] = React.useState(!!sup)
    const hasValidClientId = !!id && Number(id) > 0;
    const [allProducts, setAllProducts] = React.useState(() => {
        if (sup) {
            const supplier = JSDB().getSupplier(Number(id))?.first;
            return toArrayOrEmpty(onlyClientProduct
                ? supplier?.getActiveProducts?.()
                : JSDB().getSpecificSupplierProducts(id));
        }
        if (!hasValidClientId) {
            return toArrayOrEmpty(JSDB().getAllClientProduct(true).first);
        }
        const client = JSDB().getClient(Number(id))?.first;
        return toArrayOrEmpty(onlyClientProduct ? client?.getActiveProducts?.() : JSDB().getAllClientProduct(true).first);
    });

    const pricesQueryKey = sup ? SUPPLIER_PRODUCTS : CUSTOMER_PRODUCTS;
    const {
        data: prices,
        isLoading,
        refetch
    } = useQuery(
        [pricesQueryKey, id, dateObjectToString(date)],
        () => (sup
            ? getSupplierProductsPrices(id, dateObjectToString(date), true)
            : getCustomerProductsPrices(id, dateObjectToString(date), true, undefined, true, true)
        ).catch(() => {
            dispatch({type: SNACKBAR_OPEN, open: true, message: 'שגיאה בגישה לנתונים', variant: 'alert', alertSeverity: 'error'});
            return [];
        }),
        {
            refetchOnReconnect: false,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: hasValidClientId,
        }
    );
    React.useEffect(() => {
        if (!hasValidClientId) return;
        cache.removeQueries(pricesQueryKey);
        refetch();
    }, [dispatch, sup, hasValidClientId]);
    React.useEffect(() => {
        if (!isLoading) {
            const fromApi = prices?.filter((p) => (!onlyClientProduct || p.available && p.totalPrice > 0)) ?? [];
            if (fromApi.length > 0 || !sup) {
                setAllProducts(fromApi);
            } else {
                const supplier = JSDB().getSupplier(Number(id))?.first;
                setAllProducts(toArrayOrEmpty(onlyClientProduct
                    ? supplier?.getActiveProducts?.()
                    : JSDB().getSpecificSupplierProducts(id)));
            }
        }
    }, [prices, onlyClientProduct, sup, isLoading, id]);

    const [newItem, setNewItem] = React.useState(undefined);
    const [multiSelectProducts, setMultiSelectProducts] = React.useState(false);
    const [addProductOpen, setAddProductOpen] = React.useState(false);
    const [addProductInput, setAddProductInput] = React.useState('');
    const addProductInputRef = useRef<HTMLInputElement | null>(null);
    const addProductSearchRef = useRef('');
    const selRef = useRef<any>();
    const taklitLookupRef = useRef<Map<number, TaklitProduct>>(new Map());
    const taklitReadyRef = useRef(false);
    const useTaklitOnAdd = !sup && isTaklitEnabled();
    React.useEffect(() => {
        if (!useTaklitOnAdd || !hasValidClientId) {
            taklitLookupRef.current = new Map();
            taklitReadyRef.current = false;
            return;
        }
        let cancelled = false;
        taklitReadyRef.current = false;
        loadTaklitLookup(date).then((map) => {
            if (!cancelled) {
                taklitLookupRef.current = map;
                taklitReadyRef.current = true;
            }
        });
        return () => { cancelled = true; };
    }, [useTaklitOnAdd, hasValidClientId, date]);
    const [externalIdSearch, setExternalIdSearch] = React.useState(parseInt(localStorage.getItem('externalIdOrders') ?? '0') == 1);
    // covers products with a second unit, leftover wrapped_amount after the unit was removed, and/or an order-only third unit
    const withExtraUnit = products.some((p) => showsWrappedColumn(p))
    const variableConversion = isVariableConversionRate();
    const notePlacementCounter = useRef(products.length > 0 ? Math.max(...products.map(p => p.notePlacement ?? 0)) + 1 : 0);
    React.useEffect(() => {
        notePlacementCounter.current =
            products.length > 0 ? Math.max(...products.map((p) => p.notePlacement ?? 0)) + 1 : 0;
    }, [products]);
    React.useEffect(() => {
        // Multi-select keeps focus on the autocomplete so the user can keep picking.
        if (multiSelectProducts) {
            setNewItem(undefined);
            return;
        }
        if (products.length > 0 && selRef?.current?.children && newItem) {
            // any extra unit (second and/or order-only third) renders into the same wrapped
            // cell - jump there for orders regardless of whether it's second-only, third-only,
            // or both (a strict length===2 check here would miss products with both units).
            const hasExtraUnit = newItem.available_units.length >= 2
            const inpLoc = withExtraUnit ? ((hasExtraUnit && jumpToWrapped) ? 1 : (2 + (variableConversion ? 1 : 0))) : 1
            if (selRef?.current?.children[selRef.current.children.length - 2]?.className?.includes('autocomp')) {
                selRef?.current?.children[selRef.current.children.length - 3]?.children[inpLoc]?.getElementsByTagName("input")[0]?.focus()
            } else {
                selRef?.current?.children[selRef.current.children.length - 2]?.children[inpLoc]?.getElementsByTagName("input")[0]?.focus()
            }


        }
        setNewItem(undefined)
    }, [newItem,jumpToWrapped, multiSelectProducts, variableConversion]);
    const unitSum = roundDecimals(products.reduce((sum, x) => sum + ((x.in_unit && x.in_unit > 0) ? x.quantity * (x.in_unit ?? 0) : 0), 0));
    const costSum = roundDecimals(products.reduce((sum, x) => sum + (x.costPrice ? x.costPrice : 0) * (x.quantity + (x.quantitySecond ?? 0) * (x.conversion_ratio ?? 0)), 0));
    const displayNoteColumn = products.some((p) => p.notes)
    const displayQuantityColumn = products.some((p) => p.quantityReturns)
    const displayCostPrice = products.some((p) => p.costPrice)
    const [existingOldProducts, setexistingOldProducts] = React.useState([])
    const [removedProducts, setremovedProducts] = React.useState([])
    const [existingOrderProducts, setexistingOrderProducts] = React.useState([])
    const [notExistingOrderProducts, setnotExistingOrderProducts] = React.useState([])
    const [withDiscount, setWithDiscount] =React.useState<boolean>(parseInt(localStorage.getItem('withDiscount') ?? '0') == 1);
    React.useEffect(() => {
        if (displayOldProducts) {
            const existingOldProductsTemp = []
            const removedProductsTemp = []
            oldProducts?.forEach((p) => {
                if (products.some((p2) => p2.id == p.id)) {
                    existingOldProductsTemp.push(p)
                } else {
                    removedProductsTemp.push(p)
                }
            });
            setexistingOldProducts(existingOldProductsTemp)
            setremovedProducts(removedProductsTemp)
        } else {
            setexistingOldProducts([])
            setremovedProducts([])
        }

    }, [displayOldProducts]);
    React.useEffect(() => {
        if (displayOrderProducts) {
            const existingOrderProductsTemp = []
            const notExistingOrderProductsTemp = []

            displayOrderProducts && orderProducts?.forEach((p) => {
                if (products.some((p2) => p2.id == p.id)) {
                    existingOrderProductsTemp.push(p)
                } else {
                    notExistingOrderProductsTemp.push(p)
                }
            });
            setexistingOrderProducts(existingOrderProductsTemp)
            setnotExistingOrderProducts(notExistingOrderProductsTemp)
        } else {
            setexistingOrderProducts([])
            setnotExistingOrderProducts([])
        }

    }, [displayOrderProducts]);


    // Numeric columns share the free width evenly (the inputs themselves are compact),
    // so neither edit nor read-only mode ends up with the numbers shoved into a corner.
    const numericHeaderSx = {px: 0.5, whiteSpace: 'nowrap'} as const;

    return (
        <TableContainer component={Paper}>
            <Table size='small' aria-label='a dense table'>
                <TableHead>
                    <TableRow style={{backgroundColor: theme.palette.primary.light}}>
                        <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='left'>
                            {onTogglePositionSort ? (
                                <Chip
                                    label={<FormattedMessage id='Product'/>}
                                    size='small'
                                    color={sortByPosition ? 'primary' : 'default'}
                                    variant={sortByPosition ? 'filled' : 'outlined'}
                                    onClick={onTogglePositionSort}
                                    sx={{cursor: 'pointer', fontWeight: 'bold'}}
                                />
                            ) : (
                                <Typography variant='h5' fontWeight='bold'>
                                    <FormattedMessage id='Product'/>
                                </Typography>
                            )}
                        </TableCell>
                        {displayOrderProducts ?
                            <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                                <Typography variant='h5' fontWeight='bold'>
                                    הזמנה
                                </Typography>
                            </TableCell>
                            : undefined
                        }

                        {withExtraUnit ? <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='left'>
                            <Typography variant='h5' fontWeight='bold'>
                                {variableConversion ? 'רוחב' : 'תיאור'}
                            </Typography>
                        </TableCell> : undefined}
                        {variableConversion && withExtraUnit ? <TableCell sx={numericHeaderSx} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                אורך
                            </Typography>
                        </TableCell> : undefined}
                        <TableCell sx={numericHeaderSx} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                כמות
                            </Typography>
                        </TableCell>

                        {withReturns && (displayQuantityColumn || onProductChange) ?
                            <TableCell sx={numericHeaderSx} align='center'>
                                <Typography variant='h5' fontWeight='bold'>
                                    חזרות
                                </Typography>
                            </TableCell> : undefined}
                        <TableCell sx={numericHeaderSx} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                מחיר
                            </Typography>
                        </TableCell>
                        {withDiscount ? <TableCell sx={numericHeaderSx} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                הנחה
                            </Typography>
                        </TableCell> : undefined}
                        <TableCell sx={numericHeaderSx} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                {/* eslint-disable-next-line react/no-unescaped-entities */}
                                סה''כ
                            </Typography>
                        </TableCell>
                        {displayCost && displayCostPrice ?
                            <TableCell sx={numericHeaderSx} align='center'>
                                <Typography variant='h5' fontWeight='bold'>
                                    עלות(לפני מעמ)
                                </Typography>
                            </TableCell>
                            : undefined}
                        {
                            (displayNoteColumn || onProductChange) ?
                                <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                                    <Typography variant='h5' fontWeight='bold'>
                                        הערות
                                    </Typography>
                                </TableCell>
                                : undefined
                        }
                    </TableRow>


                </TableHead>
                <TableBody ref={selRef}>
                    {products.map((row, i) => (
                        <ProductRowMemo oldProducts={existingOldProducts} key={i} displayNoteColumn={displayNoteColumn}
                                        displayQuantityColumn={displayQuantityColumn} row={row}
                                        onProductChange={onProductChange ? (product: IItem) => onProductChange(product, i) : undefined} i={i}
                                        disableHoverableIncrementer={disableHoverableIncrementer}
                                        displayCostPrice={displayCostPrice} displayCost={displayCost}
                                        withReturns={withReturns} withExtraUnit={withExtraUnit}
                                        existingOrderProducts={existingOrderProducts}
                                        externalIdSearch={externalIdSearch}
                                        withDiscount={withDiscount} jumpToWrapped={jumpToWrapped}
                                        enterMovesDown={enterMovesDown} variableConversion={variableConversion}/>
                    ))}
                    {displayOldProducts && removedProducts?.map((row, i) => (
                        <ProductRowMemo removedProduct={true} key={i} displayNoteColumn={displayNoteColumn}
                                        displayQuantityColumn={displayQuantityColumn} row={row} i={i}
                                        disableHoverableIncrementer={disableHoverableIncrementer}
                                        displayCostPrice={displayCostPrice} displayCost={displayCost}
                                        withReturns={withReturns} withExtraUnit={withExtraUnit}
                                        externalIdSearch={externalIdSearch}
                                        withDiscount={withDiscount} jumpToWrapped={jumpToWrapped}
                                        enterMovesDown={enterMovesDown} variableConversion={variableConversion}/>
                    ))}
                    {displayOrderProducts && notExistingOrderProducts?.map((row, i) => (
                        <ProductRowMemo orderProducts={true} key={i} displayNoteColumn={displayNoteColumn}
                                        displayQuantityColumn={displayQuantityColumn} row={row} i={i}
                                        disableHoverableIncrementer={disableHoverableIncrementer}
                                        displayCostPrice={displayCostPrice} displayCost={displayCost}
                                        withReturns={withReturns} withExtraUnit={withExtraUnit}
                                        externalIdSearch={externalIdSearch} jumpToWrapped={jumpToWrapped}
                                        withDiscount={withDiscount}
                                        enterMovesDown={enterMovesDown} variableConversion={variableConversion}/>
                    ))}
                    {onProductChange ? <TableRow className={'autocomp'}>
                        <TableCell colSpan={6} sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <div style={{display: 'flex', alignItems: 'center', gap: 8, width: '100%'}}>
                                <Autocomplete
                                    sx={{flex: 1}}
                                    value={null}
                                    inputValue={addProductInput}
                                    onInputChange={(_event, value, reason) => {
                                        // Keep the family/group search after a pick in multi-select.
                                        if (multiSelectProducts && reason === 'reset') {
                                            setAddProductInput(addProductSearchRef.current);
                                            return;
                                        }
                                        addProductSearchRef.current = value;
                                        setAddProductInput(value);
                                    }}
                                    open={addProductOpen}
                                    onOpen={() => setAddProductOpen(true)}
                                    onClose={(_event, reason) => {
                                        if (multiSelectProducts && reason === 'selectOption') {
                                            return;
                                        }
                                        setAddProductOpen(false);
                                    }}
                                    blurOnSelect={!multiSelectProducts}
                                    clearOnBlur={!multiSelectProducts}
                                    disableCloseOnSelect={multiSelectProducts}
                                    ListboxProps={multiSelectProducts ? {
                                        onMouseDown: (event) => {
                                            event.preventDefault();
                                        }
                                    } : undefined}
                                    onChange={async (_event, value) => {
                                            if (value) {
                                                let iItem = itemApiIInternal(sup ? JSDB().getSupplier(Number(id)).first : JSDB().getClient(Number(id)).first, dateObjectToString(date), value.id, sup);
                                                iItem.quantity = 0;
                                                iItem.forceShow = true;
                                                iItem.notePlacement = notePlacementCounter.current;
                                                notePlacementCounter.current += 1;
                                                if (useTaklitOnAdd) {
                                                    let lookup = taklitLookupRef.current;
                                                    if (!taklitReadyRef.current) {
                                                        lookup = await loadTaklitLookup(date);
                                                        taklitLookupRef.current = lookup;
                                                        taklitReadyRef.current = true;
                                                    }
                                                    iItem = applyTaklitPriceFromLookup(iItem, lookup, {markTouched: true}).item;
                                                }
                                                onProductChange(iItem);
                                                if (multiSelectProducts) {
                                                    setAddProductOpen(true);
                                                    requestAnimationFrame(() => {
                                                        addProductInputRef.current?.focus();
                                                    });
                                                } else {
                                                    setNewItem(iItem);
                                                    setAddProductInput('');
                                                }
                                            }
                                        }
                                    }
                                    loading={isLoading}
                                    options={allProducts}
                                    getOptionLabel={(o) => `${externalIdSearch || o.external_id != '-1' && o.external_id != '' ? o.external_id : o.id}  - ${o.name}`}
                                    filterOptions={(options, {inputValue}) => {
                                        return options.filter(o => {
                                                return subStringMatch(inputValue.toLowerCase(), [externalIdSearch || o.external_id != '-1' && o.external_id != '' ? o.external_id : o.id, o.name.toLowerCase()])
                                            }
                                        ).sort((a, b) => {
                                            if (inputValue == '') {
                                                return a.position > b.position ? 1 : -1
                                            } else {
                                                const n1 = (externalIdSearch || a.external_id != '-1' && a.external_id != '' ? a.external_id : a.id)
                                                const n2 = (externalIdSearch || b.external_id != '-1' && b.external_id != '' ? b.external_id : b.id)
                                                const nn1 = Number(n1)
                                                const nn2 = Number(n2)
                                                if (!isNaN(nn1) && !isNaN(nn2)) {
                                                    return nn1 >= nn2 ? 1 : -1
                                                } else if (!isNaN(nn1)){
                                                    return 1
                                                } else if (!isNaN(nn2)){
                                                    return -1
                                                }
                                                else
                                                    return n1 > n2 ? 1 : -1
                                            }
                                        })
                                    }}
                                    size='small'
                                    fullWidth
                                    autoHighlight
                                    renderOption={(props, option) => {
                                        const pickedCount = products.filter(p => p.id === option.id).length;
                                        return (
                                            <li {...props} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                                <span>{`${externalIdSearch || option.external_id != '-1' && option.external_id != '' ? option.external_id : option.id}  - ${option.name}`}</span>
                                                {pickedCount > 0 && (
                                                    <span style={{display: 'flex', alignItems: 'center', marginLeft: 8}}>
                                                        <CheckCircleIcon color='success' fontSize='small' />
                                                        <span style={{fontSize: 12, marginLeft: 2}}>{pickedCount > 1 ? `x${pickedCount}` : ''}</span>
                                                    </span>
                                                )}
                                            </li>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={'הוסף מוצר'}
                                            fullWidth
                                            size='small'
                                            inputRef={addProductInputRef}
                                        />
                                    )}
                                />
                                <Chip
                                    size="small"
                                    color={multiSelectProducts ? 'primary' : 'default'}
                                    variant={multiSelectProducts ? 'filled' : 'outlined'}
                                    label={
                                        <FormControlLabel
                                            sx={{m: 0, '& .MuiFormControlLabel-label': {fontSize: 12}}}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={multiSelectProducts}
                                                    onChange={(e) => {
                                                        setMultiSelectProducts(e.target.checked);
                                                        if (e.target.checked) {
                                                            setAddProductOpen(true);
                                                            requestAnimationFrame(() => {
                                                                addProductInputRef.current?.focus();
                                                            });
                                                        } else {
                                                            setAddProductOpen(false);
                                                        }
                                                    }}
                                                    sx={{p: 0.25}}
                                                />
                                            }
                                            label="בחירה מרובה"
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    }
                                    sx={{flexShrink: 0}}
                                />
                            </div>
                        </TableCell>
                        <TableCell colSpan={1} sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <FormControlLabel
                                value='low'
                                control={
                                    <Checkbox checked={onlyClientProduct} onChange={(e) => setOnlyClientProduct(e.target.checked)}/>
                                }
                                label='זמינים'
                            />


                        </TableCell>
                    </TableRow> : undefined}
                    {products.length > 1 ? <TableRow style={{backgroundColor: '#F3F3F3'}}>
                        <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='left'>
                            <Typography variant='h5' fontWeight='bold'>
                                סיכום
                            </Typography>
                        </TableCell>
                        {
                            displayOrderProducts ?
                                <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                                    <Typography variant='h5' fontWeight='bold'>
                                        {existingOrderProducts.reduce((sum, x) => sum + x.quantity + x.quantitySecond, 0)}
                                    </Typography>
                                </TableCell>
                                : undefined
                        }
                        {withExtraUnit ? <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='left'>
                            <Typography variant='h5' fontWeight='bold'>
                                {roundDecimals(products.reduce((sum, x) => sum + x.quantitySecond, 0), 2)}
                            </Typography>
                            {/* order-only third unit (no conversion): summed separately, never mixed into the second-unit sum above */}
                            {products.some((x) => hasThirdUnit(x) || (x.quantityThird ?? 0) !== 0) ? (
                                <Typography variant='h5' fontWeight='bold'>
                                    {roundDecimals(products.reduce((sum, x) => sum + (x.quantityThird ?? 0), 0), 2)}
                                </Typography>
                            ) : undefined}
                        </TableCell> : undefined}
                        {variableConversion && withExtraUnit ? <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'/> : undefined}

                        <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>

                            <Typography variant='h5' fontWeight='bold'>
                                {roundDecimals(products.reduce((sum, x) => sum + x.quantity + x.conversion_ratio*x.quantitySecond, 0), 2)}
                            </Typography>

                            {unitSum > 0 ? <Typography variant='h5'>({unitSum}) </Typography> : undefined}


                        </TableCell>
                        {withReturns && (displayQuantityColumn || onProductChange) ? <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                {roundDecimals(products.reduce((sum, x) => sum + x.quantityReturns, 0))}
                            </Typography>
                        </TableCell> : undefined}


                        <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <Typography variant='h5' fontWeight='bold'>

                            </Typography>
                        </TableCell>
                        {withDiscount ? <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <Typography variant='h5' fontWeight='bold'>

                            </Typography>
                        </TableCell> : undefined}
                        <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                            <Typography variant='h5' fontWeight='bold'>
                                {/* eslint-disable-next-line react/no-unescaped-entities */}

                            </Typography>
                        </TableCell>
                        {displayCost && displayCostPrice ?
                            <TableCell dir='ltr' sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                                <Typography variant='h5' fontWeight='bold'>
                                    {costSum.toLocaleString()}
                                    <IconCurrencyShekel size={10} color='black'/>
                                </Typography>
                            </TableCell>
                            : undefined}
                        {(displayNoteColumn || onProductChange) ?
                            <TableCell sx={{paddingRight: 0, paddingLeft: 0}} align='center'>
                                <Typography variant='h5' fontWeight='bold'>

                                </Typography>
                            </TableCell>
                            : undefined}
                    </TableRow> : undefined}

                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default memo(CustomerProductsPreviewList);
